import { z } from 'zod';

export const supportSchema = z
  .literal('conversions')
  .or(z.literal('revenue'))
  .array();

export type Support = z.infer<typeof supportSchema>;
